import Image from 'components/Image'
import HERO_IMAGE from 'images/experiential-hero.png'
import CtaLink from 'components/ui/CtaLink'

const HeroSection = () => {
  return (
    <div className="relative w-full">
      <div className="relative w-full">
        <div className="absolute inset-0">
          <Image
            className="h-full w-full object-cover"
            layout="fill"
            src={HERO_IMAGE}
            priority
          />
          <div className="absolute inset-0 opacity-70 bg-linear-to-r from-black via-gray-800 to-gray-800" />
        </div>
        <div className="relative px-4 py-16 sm:px-6 sm:py-24 lg:py-32 lg:px-8 md:max-w-screen-xl mx-auto">
          <h1 className="text-4xl font-extrabold tracking-tight sm:text-5xl">
            <span className="block text-white tracking-wide uppercase">
              Experiential Marketing
            </span>
            <span className="block text-orange-100 tracking-wide uppercase">
              with BFT
            </span>
          </h1>
          <p className="mt-6 max-w-lg text-xl text-white font-bold sm:max-w-3xl">
            BFT&apos;s Experiential Marketing division specializes in immersing
            consumers through revolutionary branded mobile experiences that are
            creatively fun, interactive and maximize direct customer engagement.
          </p>
          <div className="mt-10 max-w-max">
            <CtaLink href="/experiential-marketing/form">Get branded</CtaLink>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HeroSection
